//https://github.com/minhtranite/react-progress-bar-plus

/**
 * Customize by @author Nin
 * It can be used by 2 ways:
 * 1/Window event
 */
 import React from 'react';
 import {EVENT} from '../../../common/events/listEvents';
 class LoadingBar extends React.Component {
   constructor(props) {
     super(props);
     this.currentUrl = this.props.url;
   }
   static defaultProps  = {
     className: '',
     color: '#e2a225',
     height: 5,
     hideDelay: .3,
     percent: 0,
     speed: .3,
     intervalTime: 300,
     style: {}
   }
 
   state = {
     percent: this.props.percent,
     isStopLoading: false
   };
 
   componentDidMount = () => {
     this.handleProps(this.props);
       window.listenEvent(EVENT.START_SPINNING, this.actionEventLoading)
       window.listenEvent(EVENT.STOP_SPINNING, this.actionEventStopLoading)
   };
 
 
   actionEventLoading = () => {
     this.currentUrl = '';
     let percent = this.state.percent;
 
     if (percent < 0 || percent >= 100) {
       percent = 0;
     }
 
     if (percent > 0 && percent < 100) {
       return;
     }
     
     if (percent >= 0 && percent < 99) {
       if (this.interval) {
         clearInterval(this.interval);
       }
       this.interval = setInterval(this.increment, this.props.intervalTime || LoadingBar.defaultProps.intervalTime);
     }
 
     if (percent >= 100) {
       this.setState({
         percent: 99.9
       }, () => {
         this.timeout = setTimeout(() => {
           this.setState({
             percent: -1
           });
         }, 400);
       });
     } else {
       this.setState({
         percent
       });
     }
   }
 
   actionEventStopLoading = () => {
     if (!this.state.isStopLoading) {
       this.setState({
         isStopLoading: true,
       });
 
       if(this.state.percent < 98){
         this.setState({
           percent: 98
         });
         setTimeout(() => {
           this.setState({
             percent: 99.9
           });
         }, 50);
       }
       this.endProcessTimeout = setTimeout(() => {
         this.setState({
           percent: 100,
           isStopLoading: false
         });
         if (this.interval) {
           clearInterval(this.interval);
         }
         if (this.timeout) {
           clearTimeout(this.timeout);
         }
 
         if (this.endProcessTimeout) {
           clearTimeout(this.endProcessTimeout);
         }
       }, 200);
     }
   }
 
   handleProps = (props) => {
     const { percent, intervalTime } = props;
     if (percent >= 0 && percent < 99) {
       if (this.interval) {
         clearInterval(this.interval);
       }
       this.interval = setInterval(this.increment, intervalTime);
     }
 
     if (percent >= 100) {
       this.setState({
         percent: 99.9
       }, () => {
         this.timeout = setTimeout(() => {
           this.setState({
             percent: -1
           });
         }, 400);
       });
     } else {
       this.setState({
         percent
       });
     }
   };
 
   increment = () => {
     let { percent } = this.state;
     percent += ((Math.random() + 1) - Math.random());
     percent = percent < 99 ? percent : 99;
     this.setState({
       percent
     });
   };
 
   componentWillUnmount = () => {
     if (this.interval) {
       clearInterval(this.interval);
     }
     if (this.timeout) {
       clearTimeout(this.timeout);
     }
     window.stopListenEvent(EVENT.START_SPINNING)
     window.stopListenEvent(EVENT.STOP_SPINNING)
   };
 
   componentWillReceiveProps = (nextProps) => {
     if (this.interval) {
       clearInterval(this.interval);
     }
     if (this.timeout) {
       clearTimeout(this.timeout);
     }
     this.handleProps(nextProps);
   };
 
   render () {
     const { percent, isStopLoading } = this.state;
     const containerStyle = {
       opacity: percent < 100 ? 1 : 0,
       WebkitTransition: `${this.props.speed}s opacity`,
       transition: `${this.props.speed}s opacity`,
       WebkitTransitionDelay: `${percent < 100 ? 0 : this.props.hideDelay}s`,
       transitionDelay: `${percent < 100 ? 0 : this.props.hideDelay}s`,
       display: `${(percent < 0 || percent >= 100) ? 'none' : ''}`,
     };
   
     const barStyle = {
       position: 'fixed',
       top: 0,
       left: 0,
       width: `${percent}%`,
       maxWidth: '100% !important',
       height: `${this.props.height}px`,
       boxShadow: '1px 1px 1px rgba(0,0,0,0.4)',
       borderRadius: '0 1px 1px 0',
       WebkitTransition: `${this.props.speed}s width, ${this.props.speed}s background-color`,
       transition: `${this.props.speed}s width, ${this.props.speed}s background-color`,
       ...this.props.style
     };
 
     barStyle.backgroundColor = this.props.style.backgroundColor || this.props.color;
 
     if (this.props.view !== 'euroView' && this.currentUrl == this.props.url && !this.props.reloadInternal && isStopLoading) {
       return null;
     }
 
     this.currentUrl = this.props.url;
     return (
       <div className={'loadingComponent ' + this.props.className} style={containerStyle}>
         { this.props.view !== 'euroView' ? <i className="loading"/> : <div style={barStyle}></div> }
       </div>
     );
   }
 }
 
 export default LoadingBar;
 


// WEBPACK FOOTER //
// ./src/app/components/BaseComponent/LoadingComponent/index.js